(function() {
  "use strict";
  angular.module("marketPlace.games", []);
})();
